(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow"] && !Shopify.designMode) return;
  try {
    
  const initializeHeroMotion = (root = document) => {
    const sections = root.querySelectorAll('.slideshow-section--hero-motion:not(.hero-motion-ready)');

    sections.forEach((section) => {
      section.classList.add('hero-motion-ready');

      if (!('IntersectionObserver' in window)) {
        section.classList.add('is-visible');
        return;
      }

      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              observer.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.18 }
      );

      observer.observe(section);
    });
  };

  initializeHeroMotion();
  document.addEventListener('shopify:section:load', (event) => initializeHeroMotion(event.target));

  } catch(e) { console.error(e); }
})();
})();
